import React, { useRef } from "react";
import {
  FaHome,
  FaTshirt,
  FaMobileAlt,
  FaGamepad,
  FaPaw,
  FaCouch,
  FaCar,
  FaMoneyBillWave,
  FaBuilding,
  FaShoppingBag,
  FaPalette,
  FaBook,
  FaDumbbell,
  FaTools,
  FaChair,
  FaMusic,
  FaChild,
  FaHeartbeat,
  FaLeaf,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";

const categoryIcons = {
  fashion: <FaTshirt />,
  electronic: <FaMobileAlt />,
  game: <FaGamepad />,
  "pet shop": <FaPaw />,
  furniture: <FaCouch />,
  vehicle: <FaCar />,
  rent: <FaMoneyBillWave />,
  property: <FaBuilding />,
  "house for rent": <FaHome />,
  accessories: <FaShoppingBag />,
  cosmetics: <FaPalette />,
  books: <FaBook />,
  sport: <FaDumbbell />,
  tools: <FaTools />,
  household: <FaChair />,
  music: <FaMusic />,
  kids: <FaChild />,
  health: <FaHeartbeat />,
  gardening: <FaLeaf />,
};

const CategorySection = ({
  categories,
  selectedCategory,
  handleCategoryPress,
}) => {
  const scrollContainerRef = useRef(null);

  const scrollLeft = () => {
    scrollContainerRef.current.scrollBy({
      top: 0,
      left: -300,
      behavior: "smooth",
    });
  };

  const scrollRight = () => {
    scrollContainerRef.current.scrollBy({
      top: 0,
      left: 300,
      behavior: "smooth",
    });
  };

  return (
    <div className="relative w-full mb-6">
      <div className="relative">
        <button
          onClick={scrollLeft}
          className="absolute left-0 top-1/2 transform -translate-y-1/2 z-10 bg-gray-200 dark:bg-gray-700 text-gray-900 dark:text-gray-100 p-3 rounded-full shadow-lg"
        >
          <FaChevronLeft size={24} />
        </button>
        <button
          onClick={scrollRight}
          className="absolute right-0 top-1/2 transform -translate-y-1/2 z-10 bg-gray-200 dark:bg-gray-700 text-gray-900 dark:text-gray-100 p-3 rounded-full shadow-lg"
        >
          <FaChevronRight size={24} />
        </button>
        <div
          ref={scrollContainerRef}
          className="flex gap-8 overflow-x-auto p-4 scrollbar-hide"
          style={{
            scrollBehavior: "smooth",
            paddingLeft: "50px",
            paddingRight: "50px",
          }}
        >
          {categories.slice(0, 19).map((category) => (
            <div
              key={category.category_id}
              onClick={() => handleCategoryPress(category.category_id)}
              className={`cursor-pointer flex flex-col items-center justify-center transition-all duration-300 transform hover:scale-105 ${
                parseInt(selectedCategory) === category.category_id
                  ? "text-white"
                  : "text-gray-700 dark:text-gray-300"
              }`}
            >
              <div
                className={`flex items-center justify-center rounded-full transition-colors duration-300 ${
                  parseInt(selectedCategory) === category.category_id
                    ? "bg-blue-500 text-white"
                    : "bg-white text-gray-700 border border-gray-300 dark:bg-gray-800 dark:text-gray-300"
                }`}
                style={{ width: "120px", height: "120px" }}
              >
                <div className="text-4xl">
                  {categoryIcons[category.name.toLowerCase()] || <FaHome />}
                </div>
              </div>
              <span
                className={`text-center mt-3 font-medium text-xl ${
                  parseInt(selectedCategory) === category.category_id
                    ? "text-gray-700 dark:text-white"
                    : "text-gray-700 dark:text-white"
                }`}
              >
                {category.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}  
export default CategorySection;
